import { useEffect, useState } from 'react';
/**
 * React hook that returns if the application is online
 * is click outside the reference element
 *
 * @param host - Is the host to see if it's reachable
 * @return The service worker
 *
 */
export function useOnlineStatus(host: string) {
	const [onlineStatus, setOnlineStatus] = useState<boolean | null>(null);
	useEffect(() => {
		// Initialize check
		const onlineHandler = () => {
			console.log(`THE PAGE IS ONLINE`);
			setOnlineStatus(true);
		};
		const offlineHandler = () => {
			console.log(`THE PAGE IS OFFLINE`);
			setOnlineStatus(false);
		};

		isReachable(host)
			.then(() => {
				setOnlineStatus(true);
			})
			.catch(() => {
				setOnlineStatus(false);
			});

		window.addEventListener('online', onlineHandler);
		window.addEventListener('offline', offlineHandler);

		return () => {
			window.removeEventListener('online', onlineHandler);
			window.removeEventListener('offline', offlineHandler);
		};
	}, []);
	return onlineStatus;
}

async function isReachable(url: string) {
	const resp = await fetch(url, { method: 'HEAD', mode: 'no-cors' });
	return resp && (resp.ok || resp.type === 'opaque');
}
